import { useContext, useState } from 'react';

import { ApplicationContext } from '../../../../../../shared/source/context/context';
import { useTablePagination } from '../../../common/data-grids/common/use-table-pagination';
import { JobOpeningsDataGrid } from '../../../common/data-grids/jobs/JobsDataGrid';
import { useJobOpeningsColumns } from '../../../common/data-grids/jobs/use-jobs-columns';
import { useGlobalSearchJobsBySkillQuery } from '../../../query-hooks/global-search/jobs';
import { jobPageUrl } from '../../job-list/constants';

import type { SortOption } from '../../talent-directory/sort-option';
import type { FunctionComponent } from 'react';

export const JobOpeningsRelatedSkillsTable: FunctionComponent<{ readonly skillIds: ReadonlyArray<string> }> = ({
    skillIds,
}) => {
    const { paginationModel, setPaginationModel } = useTablePagination();
    const { actions, translate } = useContext(ApplicationContext);
    const [sortOptions, setSortOptions] = useState<readonly SortOption[]>([]);

    const { data, isFetching, isPending } = useGlobalSearchJobsBySkillQuery({
        pagination: {
            page: paginationModel.page,
            size: paginationModel.pageSize,
        },
        skillIds,
        sortedFields: sortOptions,
    });

    const jobs = data?.data ?? [];
    const pagination = data?.pagination ?? { count: 0, page: 0, pages: 0, size: 0 };

    const noDataMessage = translate('pages.global-search.no-data.job-openings');

    const navigateToJobPage = (jobId: string): void => actions.navigateTo(jobPageUrl(jobId));

    const columns = useJobOpeningsColumns(skillIds);

    return (
        <JobOpeningsDataGrid
            columns={columns ?? []}
            isFetching={isFetching}
            isPending={isPending}
            noDataMessage={noDataMessage}
            paginationModel={paginationModel}
            rowCount={pagination.count}
            rows={jobs}
            sortOptions={sortOptions}
            onPaginationModelChange={setPaginationModel}
            onRowClick={navigateToJobPage}
            onSortOptionsChange={setSortOptions}
        />
    );
};
